import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon, WhatsappShareButton, WhatsappIcon } from "react-share";
import useAnalyticsEventTracker from "../../hooks/use-analytics";
import UserContext from "../../store/user-context";
import { getLangCode } from "../Helpers/Util/User";

const SocialMediaButtons = ({
    code,  
    score = null, 
    lang = 'en',
    quote = "I'm learning with golingo!", 
    hashtag = '#golingo', 
    extraStyles = {}
  }) => {
    const {t:translate} = useTranslation();
    const userContext = useContext(UserContext);
    const langCode = getLangCode(userContext.user.user.language);
    const gaEventTracker = useAnalyticsEventTracker('Social Share Event');

    if( langCode ) {
        lang = langCode;
    }

    let params = `code=${code}`;
    
    if( score ) {
      params += `&score=${score}`
    }

    if( lang && lang != 'en' ) {
      params += `&lang=${lang}`
    }

    let url = 'https://www.golingo.co.uk/share/?info=' + Buffer.from(params).toString('base64');

    return (
      <div className='share-options' style={extraStyles} onClick={(e)=> {e.stopPropagation();}}>
        <h6 className="share-options__title">{translate('share-title')}</h6>
        <FacebookShareButton
          url={url}
          title={quote}
          hashtag={hashtag}
          className="social-share"
          onClick={() => {
            gaEventTracker('Shared to Facebook', `${code}`);
          }}
        >
          <FacebookIcon size={28} />
        </FacebookShareButton>
        <TwitterShareButton 
          url={url}
          className="social-share"
          onClick={() => {
            gaEventTracker('Shared to Twitter', `${code}`);
          }}
        >
          <TwitterIcon size={28} />
        </TwitterShareButton>
        <WhatsappShareButton
          url={url}
          className="social-share"
          onClick={() => {
            gaEventTracker('Shared to WhatsApp', `${code}`);
          }}
        >
          <WhatsappIcon size={28} />
        </WhatsappShareButton>
      </div>
    );
  }

export default SocialMediaButtons;